// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/antd/dist/antd.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../storage/fonts/poppins/poppins-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url('../../storage/fonts/source_sans_pro/');*/

@font-face {
    font-family: 'Poppins';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 400; /* ou o peso da fonte desejado */
    font-style: normal; /* ou o estilo da fonte desejado */
}

* {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
}

body {
    overflow: hidden;
    background: #FFFFFF;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
}

html, body, #root {
    height: 100%;
}

div {
}

::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    border-radius: 20px;
}

::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 20px;
}

::-webkit-scrollbar-thumb {
    background: #CCC;
    border-radius: 20px;
}

::-webkit-scrollbar-thumb:hover {
    background: #CCC;
    border-radius: 20px;
}

input, button {
    font-family: 'Poppins', sans-serif;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

button {
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

span {

}

:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/presentation/app/app.css"],"names":[],"mappings":"AACA,uDAAuD;;AAEvD;IACI,sBAAsB;IACtB,4CAAqE;IACrE,gBAAgB,EAAE,gCAAgC;IAClD,kBAAkB,EAAE,kCAAkC;AAC1D;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA;AACA;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,yDAAyD;AAC7D;;AAEA;IACI,eAAe;IACf,yDAAyD;AAC7D;;AAEA;;AAEA;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["@import 'antd/dist/antd.css';\n/*@import url('../../storage/fonts/source_sans_pro/');*/\n\n@font-face {\n    font-family: 'Poppins';\n    src: url('../../storage/fonts/poppins/poppins-regular-webfont.woff2');\n    font-weight: 400; /* ou o peso da fonte desejado */\n    font-style: normal; /* ou o estilo da fonte desejado */\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    outline: 0;\n    box-sizing: border-box;\n    font-family: 'Poppins', sans-serif;\n}\n\nbody {\n    overflow: hidden;\n    background: #FFFFFF;\n    text-rendering: optimizeLegibility !important;\n    -webkit-font-smoothing: antialiased !important;\n}\n\nhtml, body, #root {\n    height: 100%;\n}\n\ndiv {\n}\n\n::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n    border-radius: 20px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 20px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #CCC;\n    border-radius: 20px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #CCC;\n    border-radius: 20px;\n}\n\ninput, button {\n    font-family: 'Poppins', sans-serif;\n    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\nbutton {\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\nspan {\n\n}\n\n:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
